export default __webpack_public_path__ + "static/media/empty-document-icon.a8bb2fbd.svg";